import r from "./isObject.js";
function o(t) {
  return t === t && !r(t);
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_isStrictComparable.js
// module id = 919
// module chunks = 67